// extracted by mini-css-extract-plugin
module.exports = {"mugshot":"Mugshot-module--mugshot--q_zOz","mugshot__mask":"Mugshot-module--mugshot__mask--3vEZs"};